import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _flatten from 'lodash/flatten';
import _isEmpty from 'lodash/isEmpty';
export function getItems() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    continuous = _ref.continuous,
    items = _ref.items,
    pageSize = _ref.pageSize,
    slide = _ref.slide;
  if (_isEmpty(items)) {
    return [];
  }
  if (slide) {
    // at least 4 items are needed in order to apply the slide effect
    // we also need at least pageSize * 3 items to ensure we have enough element to fill the previous next and current states
    if (items.length < 4 || items.length < pageSize * 3) {
      return _flatten([].concat(_toConsumableArray(items), _toConsumableArray(items), _toConsumableArray(items))).map(function (item, index) {
        return _objectSpread(_objectSpread({}, item), {}, {
          key: "".concat(item.key, "-").concat(index)
        });
      });
    }
    return items;
  }
  if (continuous) {
    return [].concat(_toConsumableArray(items), _toConsumableArray(items), _toConsumableArray(items));
  }
  return items;
}